import React from 'react';
import { ProductChangelog } from '../common/components/product-changelog.component';
import pkg from '../../../package.json';

const SubdivsChangelog: React.FC = () => (
  <ProductChangelog
    productName="Squarebit Subdivs"
    version={
      (pkg as { squarebitSubdivs?: { version?: string } }).squarebitSubdivs
        ?.version ?? '0.0.0'
    }
    mdPath="/changelog-squarebit-subdivs.md"
    publicRepo={null}
    showDownloadLinks={false}
  />
);

export default SubdivsChangelog;
